<ew-mat-dialog-custom>
  <section class="flex flex-col flex-auto mx-auto max-w-2xl px-10 lt-md:px-0">
    <img
      class="w-10 m-auto my-8 sm:my-5 md:my-7 xl:my-8 xl:w-16"
      src="assets/logo-edvisor.svg"
      alt="Edvisor logo" />

    <div class="mb-8 text-5xl font-medium">
      {{ 'commissions:createProfileTitle' | translate }}
    </div>

    <div class="mb-6 text-3xl font-medium">
      {{ 'commissions:companyAddress' | translate }}
    </div>

    <form class="grid gap-2" [formGroup]="profile">
      <!-- address -->
      <div class="w-full grid grid-cols-1 gap-4">
        <mat-form-field>
          <mat-label class="font-semibold mb-2">
            {{ 'commissions:addressInput' | translate }}
            <small class="text-gray-400">
              ({{ 'shared:required' | translate }})
            </small>
          </mat-label>
          <input
            matInput
            required
            placeholder="Jane Doe"
            formControlName="address" />
          <mat-error *ngIf="profile.controls['address'].errors">
            <span>{{ 'commissions:addressInput' | translate }}</span
            ><strong> {{ 'shared:isRequired' | translate }}</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <!-- country, province, city, zipcode, phone number -->
      <div class="w-full grid grid-cols-2 gap-4">
        <ew-select-country
          [width]="'100%'"
          [label]="'commissions:countryInput'"
          [isAllowedToReceiveCorporatePayments]="true"
          (valueChanged)="
            profile.patchValue({ country: $event.iso }); onCountryChange()
          ">
        </ew-select-country>

        <!-- province -->
        <ng-container *ngIf="showInputProvince">
          <mat-form-field>
            <mat-label class="font-semibold mb-2">
              {{ 'commissions:provinceInput' | translate }}
              <small class="text-gray-400">
                ({{ 'shared:required' | translate }})
              </small>
            </mat-label>
            <mat-select formControlName="province">
              <mat-option
                [value]="item.provinceId"
                *ngFor="let item of provinces">
                {{ item.name }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="profile.controls['province'].errors">
              <span>{{ 'commissions:provinceInput' | translate }}</span
              ><strong> {{ 'shared:isRequired' | translate }}</strong>
            </mat-error>
          </mat-form-field>
        </ng-container>

        <!-- city -->
        <mat-form-field>
          <mat-label class="font-semibold mb-2">
            {{ 'commissions:cityInput' | translate }}
            <small class="text-gray-400">
              ({{ 'shared:required' | translate }})
            </small>
          </mat-label>
          <input
            matInput
            required
            placeholder="Alberta"
            formControlName="city" />
          <mat-error *ngIf="profile.controls['address'].errors">
            <span>{{ 'commissions:cityInput' | translate }}</span
            ><strong> {{ 'shared:isRequired' | translate }}</strong>
          </mat-error>
        </mat-form-field>

        <!-- zip code -->
        <mat-form-field>
          <mat-label class="font-semibold mb-2">
            {{ 'commissions:postalCodeInput' | translate }}
            <small class="text-gray-400">
              ({{ 'shared:required' | translate }})
            </small>
          </mat-label>
          <input
            matInput
            required
            placeholder="12345"
            maxlength="10"
            formControlName="postalCode" />
          <mat-error *ngIf="profile.controls['address'].errors">
            <span>{{ 'commissions:postalCodeInput' | translate }}</span
            ><strong> {{ 'shared:isRequired' | translate }}</strong>
          </mat-error>
        </mat-form-field>

        <!-- phone number -->
        <mat-form-field>
          <mat-label class="font-semibold mb-2">
            {{ 'commissions:phoneInput' | translate }}
            <small class="text-gray-400">
              ({{ 'shared:required' | translate }})
            </small>
          </mat-label>
          <input
            matInput
            type="tel"
            maxlength="10"
            placeholder="99 99999999"
            formControlName="phoneNumber" />
          <mat-error *ngIf="profile.controls['phoneNumber'].errors">
            <span>{{ 'commissions:phoneInput' | translate }}</span
            ><strong> {{ 'shared:isRequired' | translate }}</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <h2>{{ 'commissions:profileInfo' | translate }}</h2>

      <div class="w-full grid grid-cols-2 gap-4">
        <!-- profilne name -->
        <mat-form-field>
          <mat-label class="font-semibold mb-2">
            {{ 'commissions:profileNameInput' | translate }}
            <small class="text-gray-400">
              ({{ 'shared:required' | translate }})
            </small>
          </mat-label>
          <input
            matInput
            required
            placeholder="Jane Doe"
            formControlName="profileName" />
          <mat-error *ngIf="profile.controls['profileName'].errors">
            <span>{{ 'commissions:profileNameInput' | translate }}</span
            ><strong> {{ 'shared:isRequired' | translate }}</strong>
          </mat-error>
        </mat-form-field>

        <!-- tax id -->
        <ng-container *ngIf="profile.controls['country'].value === 'br'">
          <mat-form-field>
            <mat-label class="font-semibold mb-2">
              {{ 'commissions:taxIdInput' | translate }}
              <small class="text-gray-400">
                ({{ 'shared:required' | translate }})
              </small>
            </mat-label>
            <input
              matInput
              placeholder="XX.XXX.XXX/0001-XX"
              mask="00.000.000/0000-00"
              [dropSpecialCharacters]="true"
              required
              formControlName="taxId" />
          </mat-form-field>
        </ng-container>
        <ng-container *ngIf="profile.controls['country'].value === 'co'">
          <mat-form-field>
            <mat-label class="font-semibold mb-2">
              NIT (Tax ID)
              <small class="text-gray-400">
                ({{ 'shared:required' | translate }})
              </small>
            </mat-label>
            <input
              matInput
              placeholder="XXX.XXX.XXX-X"
              mask="000.000.00-0||000.000.000-0"
              [dropSpecialCharacters]="true"
              required
              formControlName="taxId" />
            <mat-error *ngIf="profile.controls['taxId'].errors?.['required']">
              {{ 'commissions:taxIdInput' | translate
              }}<strong> {{ 'shared:isRequired' | translate }}</strong>
            </mat-error>
            <mat-error *ngIf="profile.controls['taxId'].errors?.['invalidNIT']">
              {{ 'shared:invalid' | translate }} NIT
            </mat-error>
          </mat-form-field>
        </ng-container>
        <ng-container *ngIf="profile.controls['country'].value === 'cl'">
          <mat-form-field>
            <mat-label class="font-semibold mb-2">
              RUT (Tax ID)
              <small class="text-gray-400">
                ({{ 'shared:required' | translate }})
              </small>
            </mat-label>
            <input
              matInput
              placeholder="XX.XXX.XXX-X"
              mask="00.000.000-A"
              [dropSpecialCharacters]="true"
              required
              formControlName="taxId" />
            <mat-error *ngIf="profile.controls['taxId'].errors?.['required']">
              {{ 'commissions:taxIdInput' | translate
              }}<strong> {{ 'shared:isRequired' | translate }}</strong>
            </mat-error>
            <mat-error *ngIf="profile.controls['taxId'].errors?.['invalidRUT']">
              {{ 'shared:invalid' | translate }} RUT
            </mat-error>
          </mat-form-field>
        </ng-container>
      </div>
      <div class="mx-auto mt-4">
        <button
          mat-flat-button
          [disabled]="!validations()"
          (click)="submit()"
          [color]="'primary'">
          {{ 'commissions:profileSubmitButton' | translate }}
        </button>
      </div>
    </form>
  </section>
</ew-mat-dialog-custom>